import { RxFileText } from "react-icons/rx";
import { useNavigate } from "react-router-dom";

import Loading from "@Components/Loading";

import {
  formatCollateral,
  formatCustomersNames,
} from "@Pages/Applications/Applications";

import { ResultsTableProps } from "./types";

import styles from "./Search.module.scss";
import { Dealership } from "@Types/dealerships";
import { Deal } from "@Types/deal";

const ResultsTable = ({ data, setFocus }: ResultsTableProps<Deal>) => {
  const navigate = useNavigate();
  const navigateToEntry = (
    e: React.MouseEvent<HTMLTableRowElement, MouseEvent>,
    entity: "loans",
    id: string
  ) => {
    e.stopPropagation();
    e.preventDefault();
    navigate(`/${entity}/${id}`);
    setFocus?.(false);
  };
  return (
    <div className={styles.tableContainer}>
      <div
        className={[styles.tableHeaderContainer, styles.topBorders].join(" ")}
      >
        <RxFileText size={30} className={styles.headerIcon} color="white" />
        Loans
      </div>
      <table className={styles.table}>
        <thead>
          <tr>
            <th align="left">Customer</th>
            <th align="left">VIN</th>
            <th align="left">Collateral</th>
          </tr>
        </thead>
        <tbody>
          {data?.loading && (
            <tr>
              <td align="center" colSpan={4}>
                <Loading size={25} text={undefined} />
              </td>
            </tr>
          )}
          {data.data?.map((deal, index) => (
            <tr
              key={index}
              onMouseDown={(e) => navigateToEntry(e, "loans", deal._id)}
            >
              <>
                <td align="left">{formatCustomersNames(deal)}</td>
                <td align="left">{deal?.data?.info?.vehicle?.VIN ?? ""}</td>
                <td align="left">{formatCollateral(deal)}</td>
              </>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export const ResultsTableDealer = ({
  data,
  setFocus,
}: ResultsTableProps<Dealership>) => {
  const navigate = useNavigate();
  const navigateToEntry = (
    e: React.MouseEvent<HTMLTableRowElement, MouseEvent>,
    entity: "dealers",
    id: string
  ) => {
    e.stopPropagation();
    e.preventDefault();
    navigate(`/${entity}/${id}`);
    setFocus?.(false);
  };
  return (
    <div className={styles.tableContainer}>
      <div
        className={[styles.tableHeaderContainer, styles.topBorders].join(" ")}
      >
        <RxFileText size={30} className={styles.headerIcon} color="white" />
        Dealers
      </div>
      <table className={styles.table}>
        <thead>
          <tr>
            <th align="left">Name</th>
          </tr>
        </thead>
        <tbody>
          {data?.loading && (
            <tr>
              <td align="center" colSpan={4}>
                <Loading size={25} text={undefined} />
              </td>
            </tr>
          )}
          {data.data?.map((dealer, index) => (
            <tr
              key={index}
              onMouseDown={(e) => navigateToEntry(e, "dealers", dealer._id)}
            >
              <>
                <td align="left">{dealer.data.info.displayName ?? ""}</td>
              </>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ResultsTable;
